var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHeaderHoverBot = function SvgIconHeaderHoverBot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DA613A",
    clipPath: "url(#icon-header-hover-bot_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.645v2a1 1 0 0 0 1 1h.333v-4H1a1 1 0 0 0-1 1ZM19 9.645h-.333v4H19a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1ZM11.667 1.978a1.672 1.672 0 0 1-1.334 1.633v1.7h-.666v-1.7a1.667 1.667 0 1 1 2-1.633ZM14 11.645a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM6 11.645a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 5.978H4a2 2 0 0 0-2 2v7.333a2 2 0 0 0 1.993 2 .336.336 0 0 1 .34.334v1.71a.333.333 0 0 0 .519.278l3.315-2.21a.666.666 0 0 1 .368-.112H16a2 2 0 0 0 2-2V7.978a2 2 0 0 0-2-2ZM6 12.311a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333Zm5.95 1.177c-.022.034-.532.823-1.95.823s-1.928-.79-1.95-.823a.333.333 0 0 1 .563-.357c.02.028.369.514 1.387.514 1.027 0 1.373-.494 1.387-.515a.336.336 0 0 1 .46-.096c.152.098.198.3.102.454ZM14 12.311a1.667 1.667 0 1 1 0-3.333 1.667 1.667 0 0 1 0 3.333Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-header-hover-bot_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgIconHeaderHoverBot;